module.exports = __webpack_public_path__ + "static/media/contest_tutorial_image.bacf4596.svg";